import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { RouterModule } from '@angular/router';
import { BreadcrumbStore } from '@workspace/ng-data-access';
import { AuraBreadcrumbNavigationComponent } from '../breadcrumb-navigation.component';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'aura-router-breadcrumb',
  templateUrl: './router-breadcrumb.component.html',
  imports: [RouterModule, AuraBreadcrumbNavigationComponent],
})
export class AuraRouterBreadcrumbComponent {
  protected readonly breadcrumbStore = inject(BreadcrumbStore);
}
